(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7966],{

/***/ 47017:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account",
      function () {
        return __webpack_require__(31461);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);





var Button = function(_param) {
    var _type = _param.type, type = _type === void 0 ? "button" : _type, children = _param.children, className = _param.className, onClick = _param.onClick, disabled = _param.disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "type",
        "children",
        "className",
        "onClick",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        type: type,
        onClick: onClick,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, "bg-gradient-to-bl from-dawnOrange-500 to-dawnPurple-500 rounded-full px-8 md:py-5 text-xs font-medium text-white uppercase", {
            "opacity-40 cursor-not-allowed": disabled
        }),
        disabled: disabled
    }, rest), {
        children: children
    }));
};



/***/ }),

/***/ 23074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41107);



/***/ }),

/***/ 1824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ Gradient; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/tailwindConfig.ts
var tailwindConfig = __webpack_require__(30049);
;// CONCATENATED MODULE: ./components/Gradient/Gradient.tsx


var tailwindColors = tailwindConfig/* theme */.r === null || tailwindConfig/* theme */.r === void 0 ? void 0 : tailwindConfig/* theme.colors */.r.colors;
var availableColors = {
    purple: tailwindColors["dawnPurple"]["500"],
    orange: tailwindColors["dawnOrange"]["500"]
};
function Gradient(param) {
    var color = param.color, _scale = param.scale, scale = _scale === void 0 ? 1 : _scale, _opacity = param.opacity, opacity = _opacity === void 0 ? 0.15 : _opacity, _right = param.right, right = _right === void 0 ? undefined : _right, _left = param.left, left = _left === void 0 ? undefined : _left, _top = param.top, top = _top === void 0 ? 0 : _top, _fixed = param.fixed, fixed = _fixed === void 0 ? false : _fixed;
    var width = 200;
    var height = 100;
    var selectedColor = availableColors[color];
    width = width * scale;
    height = height * scale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        style: {
            right: right,
            left: left,
            top: top
        },
        className: "".concat(fixed ? "fixed" : "absolute", "  z-0 overflow-hidden"),
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                filter: "url(#filter)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                    cx: "50%",
                    cy: "50%",
                    rx: "20%",
                    ry: "20%",
                    fill: selectedColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter",
                    x: "0",
                    y: "0",
                    width: width,
                    height: height,
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: Math.round(width * 0.07),
                            result: "effect1_foregroundBlur"
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Gradient/index.ts



/***/ }),

/***/ 48145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ cacheExchange; },
  "S": function() { return /* binding */ urqlUrl; }
});

// EXTERNAL MODULE: ./node_modules/@urql/exchange-graphcache/dist/urql-exchange-graphcache.mjs + 3 modules
var urql_exchange_graphcache = __webpack_require__(32559);
;// CONCATENATED MODULE: ./lib/urql/urqlCacheExchangeConfig.ts
var cacheExchangeConfig = {
    keys: {
        chat_message_seen_by_user: function() {
            return null;
        },
        chat_message_aggregate: function() {
            return null;
        },
        chat_message_aggregate_fields: function() {
            return null;
        },
        chat_room_type: function(data) {
            return data.name;
        },
        stripe_subscription: function() {
            return null;
        },
        user_chat_room: function() {
            return null;
        },
        user_support_team: function() {
            return null;
        },
        user_role: function(data) {
            return data.name;
        }
    }
};

;// CONCATENATED MODULE: ./lib/urql/urqlClient.ts


var urqlUrl = "https://api.dawn.health/v1/graphql" || 0;
var cacheExchange = (0,urql_exchange_graphcache/* cacheExchange */.HG)(cacheExchangeConfig);



/***/ }),

/***/ 31461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ account; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-urql/dist/next-urql.es.js + 1 modules
var next_urql_es = __webpack_require__(61325);
// EXTERNAL MODULE: ./node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(92432);
// EXTERNAL MODULE: ./node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(26997);
// EXTERNAL MODULE: ./lib/urql/urqlClient.ts + 1 modules
var urqlClient = __webpack_require__(48145);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./components/Navbar/Navbar.tsx + 6 modules
var Navbar = __webpack_require__(92595);
// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/form-inputs/Input/Input.tsx





var Input = /*#__PURE__*/ (0,react.forwardRef)(function Input(props, ref) {
    var disabled = props.disabled, className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: ref,
        className: classnames_default()("rounded-dawnDefault bg-dawnDark-500 bg-opacity-30 w-full px-6 py-4 font-inter border border-dawnDark-400 placeholder-dawnDark-300 text-white text-base xl:text-xl leading-8 focus:outline-none", {
            "bg-dawnDark-100": disabled
        }, className)
    }));
});

;// CONCATENATED MODULE: ./components/form-inputs/Input/index.ts


// EXTERNAL MODULE: ./components/Button/index.ts
var Button = __webpack_require__(23074);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
;// CONCATENATED MODULE: ./pages/account/index.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ($email: String!, $password: String!) {\n    stripeCreateCustomerPortalSession(email: $email, password: $password) {\n      session\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var STRIPE_CUSTOMER_PORTAL_SESSION_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject());
function AccountPage() {
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit;
    var ref1 = (0,react.useState)(""), errorMessage = ref1[0], setErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(STRIPE_CUSTOMER_PORTAL_SESSION_MUTATION), 2), sessionMutation = ref3[1];
    // Check for existing session. Delete if expired.
    (0,react.useEffect)(function() {
        var session = JSON.parse(localStorage.getItem(constants/* STRIPE_CUSTOMER_PORTAL_SESSION_LOCALSTORAGE_KEY */._X));
        if (session) {
            var sessionCreated = session === null || session === void 0 ? void 0 : session.created;
            var now = new Date().getTime() / 1000;
            // Session was created more than 5 minutes ago.
            var sessionHasExpired = Math.floor(now - sessionCreated) >= 300;
            if (sessionHasExpired) {
                localStorage.removeItem(constants/* STRIPE_CUSTOMER_PORTAL_SESSION_LOCALSTORAGE_KEY */._X);
            } else {
                window.location.href = session.url;
            }
        }
    }, []);
    function onSubmit(data) {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var email, password, sessionMutationResult, ref, ref1, session;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = data.email, password = data.password;
                        setIsLoading(true);
                        setErrorMessage("");
                        _ctx.next = 5;
                        return sessionMutation({
                            email: email,
                            password: password
                        });
                    case 5:
                        sessionMutationResult = _ctx.sent;
                        if (sessionMutationResult.error) {
                            setErrorMessage(sessionMutationResult.error.message.replace("[GraphQL] ", ""));
                        } else {
                            ;
                            session = (ref = sessionMutationResult.data) === null || ref === void 0 ? void 0 : (ref1 = ref.stripeCreateCustomerPortalSession) === null || ref1 === void 0 ? void 0 : ref1.session;
                            if (session) {
                                localStorage.setItem(constants/* STRIPE_CUSTOMER_PORTAL_SESSION_LOCALSTORAGE_KEY */._X, JSON.stringify(session));
                                window.location.href = session.url;
                            }
                        }
                        setIsLoading(false);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _onSubmit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden bg-dawnDark-700",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        left: "-50rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 8,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        right: "-30rem",
                        top: "-20rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.1,
                        right: "-40rem",
                        top: "-2rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center h-screen -mt-24",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full max-w-xl mx-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-2xl tracking-wide text-center text-white",
                                    children: "Sign In"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            onSubmit: handleSubmit(onSubmit),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            className: "block pl-1 mb-2 text-base font-normal leading-8 text-white xl:text-xl",
                                                            htmlFor: "email",
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread/* default */.Z)({
                                                            type: "email",
                                                            id: "email",
                                                            placeholder: "you@example.com",
                                                            required: true
                                                        }, register("email")))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            className: "block pl-1 mb-2 text-base font-normal leading-8 text-white xl:text-xl",
                                                            htmlFor: "password",
                                                            children: "Password"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread/* default */.Z)({
                                                            type: "password",
                                                            id: "password",
                                                            placeholder: "your password",
                                                            required: true
                                                        }, register("password")))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    className: "w-full px-10 py-5 mt-8 mb-4 text-lg font-medium tracking-widest xl:col-span-2 xl:text-base'",
                                                    type: "submit",
                                                    disabled: isLoading,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-sm md:text-base",
                                                        children: "Sign In"
                                                    })
                                                })
                                            ]
                                        }),
                                        errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full p-4 mb-8 text-center text-white",
                                            children: errorMessage
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var account = ((0,next_urql_es/* withUrqlClient */.X)(function(ssrExchange) {
    return {
        url: urqlClient/* urqlUrl */.S,
        exchanges: [
            urql_core/* dedupExchange */.B5,
            urqlClient/* cacheExchange */.H,
            ssrExchange,
            urql_core/* fetchExchange */.Ek
        ],
        fetchOptions: {
            headers: {
                "x-hasura-admin-secret": "w{^CKRE2a&?875YH3N5d@7?oLZ0siW!_"
            }
        }
    };
})(AccountPage));


/***/ }),

/***/ 41125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var _object_spread = (__webpack_require__(50337)/* ["default"] */ .Z);
var _to_consumable_array = (__webpack_require__(53929)/* ["default"] */ .Z);
var defaultTheme = __webpack_require__(75874);
module.exports = {
    purge: [
        "./pages/**/*.{js,ts,jsx,tsx}",
        "./modules/**/*.{js,ts,jsx,tsx}",
        "./lib/**/*.{js,ts,jsx,tsx}",
        "./components/**/*.{js,ts,jsx,tsx}", 
    ],
    mode: "jit",
    darkMode: false,
    theme: {
        linearBorderGradients: function(theme) {
            return {
                colors: _object_spread({
                    "orange-purple": [
                        theme("colors.dawnOrange.500"),
                        theme("colors.dawnPurple.500")
                    ]
                }, theme("colors")),
                background: _object_spread({
                    white: theme("colors.white")
                }, theme("colors"))
            };
        },
        colors: {
            dawnDark: {
                100: "#EFF2F6",
                150: "#E5E5E5",
                200: "#BBBDC5",
                300: "#858992",
                400: "#4F555F",
                500: "#19212C",
                550: "#232832",
                600: "#151B25",
                700: "#11161E",
                800: "#0D1117",
                900: "#090C10"
            },
            dawnOrange: {
                100: "#FFEEE5",
                200: "#FFD7C4",
                300: "#FFBFA1",
                400: "#FFA77E",
                500: "#FF8F5B",
                600: "#C56E45",
                700: "#8C4C2E",
                800: "#532A17",
                900: "#1A0800"
            },
            dawnPurple: {
                100: "#E9EDFB",
                200: "#C5CDF4",
                300: "#9FADEE",
                400: "#798DE8",
                500: "#536DE2",
                600: "#4055AF",
                700: "#2C3B7C",
                800: "#182149",
                900: "#040716"
            },
            dawnRed: {
                500: "#E24328"
            },
            dawnGreen: {
                500: "#E24328"
            },
            white: "#fff",
            black: "#000",
            transparent: "transparent"
        },
        extend: {
            spacing: {
                1.5: "0.375rem",
                13: "3.25rem",
                18: "4.5rem",
                22: "5.5rem",
                26: "6.5rem",
                30: "7.5rem",
                34: "8.5rem",
                38: "9.5rem",
                62: "15.5rem",
                100: "25rem",
                108: "27rem",
                500: "31.25rem"
            },
            maxWidth: {
                "1.5xl": "38rem",
                "3.5xl": "52rem",
                "8xl": "88rem",
                "9xl": "96rem"
            },
            fontFamily: {
                sans: [
                    "Epilogue"
                ].concat(_to_consumable_array(defaultTheme.fontFamily.sans)),
                inter: [
                    "Inter"
                ].concat(_to_consumable_array(defaultTheme.fontFamily.sans))
            },
            fontSize: {
                "2.5xl": "1.75rem",
                "3.5xl": "2rem",
                "5.5xl": "3.5rem",
                "6.25xl": "4rem"
            },
            lineHeight: {
                12: "3rem",
                14: "3.5rem",
                18: "4.5rem"
            },
            zIndex: {
                "-10": "-10",
                "-05": "-05"
            },
            borderWidth: {
                1.5: "1.5px"
            },
            borderRadius: {
                dawnDefault: "2.5rem"
            },
            inset: {
                "60%": "60%"
            },
            backdropBlur: {
                "1.5xl": "2.25rem"
            },
            opacity: {
                6: "0.06"
            },
            maxHeight: {
                1000: "100rem"
            },
            typography: function(theme) {
                return {
                    DEFAULT: {
                        css: {
                            a: {
                                "word-break": "break-word",
                                "overflow-wrap": "break-word",
                                fontWeight: "normal",
                                "text-decoration": "none",
                                color: theme("colors.dawnPurple.500"),
                                "&:hover": {
                                    color: theme("colors.dawnPurple.600")
                                }
                            }
                        }
                    }
                };
            }
        }
    },
    plugins: [
        __webpack_require__(50130),
        __webpack_require__(54863),
        __webpack_require__(34270),
        __webpack_require__(2112), 
    ]
};


/***/ }),

/***/ 59830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ SLUG_KEY; },
/* harmony export */   "LV": function() { return /* binding */ QUESTIONNAIRE_LOCALSTORAGE_KEY; },
/* harmony export */   "Sh": function() { return /* binding */ SIGNUP_USER_DATA_KEY; },
/* harmony export */   "_X": function() { return /* binding */ STRIPE_CUSTOMER_PORTAL_SESSION_LOCALSTORAGE_KEY; }
/* harmony export */ });
/* unused harmony exports TRIAL_KEY, CTA_AB_TEST_COOKIE, HOME_HERO_TEST_COOKIE, HOME_HERO_TEST_2_COOKIE, NO_TRIAL_TEST_COOKIE, NO_TRIAL_TEST_2_COOKIE */
var SLUG_KEY = "page";
var TRIAL_KEY = "trial";
var QUESTIONNAIRE_LOCALSTORAGE_KEY = "questionnaire-answers";
var SIGNUP_USER_DATA_KEY = "signup-user-data";
var CTA_AB_TEST_COOKIE = "cta_test";
var HOME_HERO_TEST_COOKIE = "home_hero_test";
var HOME_HERO_TEST_2_COOKIE = "home_hero_test_2";
var NO_TRIAL_TEST_COOKIE = "no_trial_test";
var NO_TRIAL_TEST_2_COOKIE = "no_trial_test_2";
var STRIPE_CUSTOMER_PORTAL_SESSION_LOCALSTORAGE_KEY = "stripe-customer-portal-session";


/***/ }),

/***/ 30049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ theme; }
/* harmony export */ });
/* harmony import */ var tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86926);
/* harmony import */ var tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tailwind_config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41125);
/* harmony import */ var _tailwind_config_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tailwind_config_js__WEBPACK_IMPORTED_MODULE_1__);


var theme = tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0___default()((_tailwind_config_js__WEBPACK_IMPORTED_MODULE_1___default())).theme;


/***/ }),

/***/ 6512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Le; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32984);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12351);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23784);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19946);
/* harmony import */ var _keyboard_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61363);
/* harmony import */ var _utils_bugs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64103);
/* harmony import */ var _internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16567);
/* harmony import */ var _hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14157);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15466);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73781);
var J=(l=>(l[l.Open=0]="Open",l[l.Closed=1]="Closed",l))(J||{}),Q=(t=>(t[t.ToggleDisclosure=0]="ToggleDisclosure",t[t.CloseDisclosure=1]="CloseDisclosure",t[t.SetButtonId=2]="SetButtonId",t[t.SetPanelId=3]="SetPanelId",t[t.LinkPanel=4]="LinkPanel",t[t.UnlinkPanel=5]="UnlinkPanel",t))(Q||{});let V={[0]:e=>({...e,disclosureState:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(e.disclosureState,{[0]:1,[1]:0})}),[1]:e=>e.disclosureState===1?e:{...e,disclosureState:1},[4](e){return e.linkedPanel===!0?e:{...e,linkedPanel:!0}},[5](e){return e.linkedPanel===!1?e:{...e,linkedPanel:!1}},[2](e,n){return e.buttonId===n.buttonId?e:{...e,buttonId:n.buttonId}},[3](e,n){return e.panelId===n.panelId?e:{...e,panelId:n.panelId}}},B=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);B.displayName="DisclosureContext";function v(e){let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(B);if(n===null){let l=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(l,v),l}return n}let h=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);h.displayName="DisclosureAPIContext";function K(e){let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h);if(n===null){let l=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(l,K),l}return n}let H=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);H.displayName="DisclosurePanelContext";function X(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(H)}function Y(e,n){return (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(n.type,V,e,n)}let Z=react__WEBPACK_IMPORTED_MODULE_0__.Fragment,ee=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(n,l){let{defaultOpen:y=!1,...u}=n,T=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),t=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(l,(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .optionalRef */ .h)(a=>{T.current=a},n.as===void 0||n.as===react__WEBPACK_IMPORTED_MODULE_0__.Fragment)),o=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),s=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(Y,{disclosureState:y?0:1,linkedPanel:!1,buttonRef:f,panelRef:o,buttonId:null,panelId:null}),[{disclosureState:i,buttonId:p},D]=s,d=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(a=>{D({type:1});let r=(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_5__/* .getOwnerDocument */ .r)(T);if(!r||!p)return;let c=(()=>a?a instanceof HTMLElement?a:a.current instanceof HTMLElement?a.current:r.getElementById(p):r.getElementById(p))();c==null||c.focus()}),P=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({close:d}),[d]),A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:i===0,close:d}),[i,d]),S={ref:t};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(B.Provider,{value:s},react__WEBPACK_IMPORTED_MODULE_0__.createElement(h.Provider,{value:P},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .OpenClosedProvider */ .up,{value:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(i,{[0]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .State.Open */ .ZM.Open,[1]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .State.Closed */ .ZM.Closed})},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:S,theirProps:u,slot:A,defaultTag:Z,name:"Disclosure"}))))}),te="button",ne=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(n,l){let y=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_7__/* .useId */ .M)(),{id:u=`headlessui-disclosure-button-${y}`,...T}=n,[t,o]=v("Disclosure.Button"),f=X(),s=f===null?!1:f===t.panelId,i=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),p=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(i,l,s?null:t.buttonRef);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(!s)return o({type:2,buttonId:u}),()=>{o({type:2,buttonId:null})}},[u,o,s]);let D=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(r=>{var c;if(s){if(t.disclosureState===1)return;switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Enter */ .R.Enter:r.preventDefault(),r.stopPropagation(),o({type:0}),(c=t.buttonRef.current)==null||c.focus();break}}else switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Enter */ .R.Enter:r.preventDefault(),r.stopPropagation(),o({type:0});break}}),d=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(r=>{switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:r.preventDefault();break}}),P=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(r=>{var c;(0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_9__/* .isDisabledReactIssue7711 */ .P)(r.currentTarget)||n.disabled||(s?(o({type:0}),(c=t.buttonRef.current)==null||c.focus()):o({type:0}))}),A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.disclosureState===0}),[t]),S=(0,_hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_10__/* .useResolveButtonType */ .f)(n,i),a=s?{ref:p,type:S,onKeyDown:D,onClick:P}:{ref:p,id:u,type:S,"aria-expanded":n.disabled?void 0:t.disclosureState===0,"aria-controls":t.linkedPanel?t.panelId:void 0,onKeyDown:D,onKeyUp:d,onClick:P};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:a,theirProps:T,slot:A,defaultTag:te,name:"Disclosure.Button"})}),le="div",re=_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.Static */ .AN.Static,oe=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(n,l){let y=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_7__/* .useId */ .M)(),{id:u=`headlessui-disclosure-panel-${y}`,...T}=n,[t,o]=v("Disclosure.Panel"),{close:f}=K("Disclosure.Panel"),s=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(l,t.panelRef,P=>{o({type:P?4:5})});(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(o({type:3,panelId:u}),()=>{o({type:3,panelId:null})}),[u,o]);let i=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .useOpenClosed */ .oJ)(),p=(()=>i!==null?i===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .State.Open */ .ZM.Open:t.disclosureState===0)(),D=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.disclosureState===0,close:f}),[t,f]),d={ref:s,id:u};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(H.Provider,{value:t.panelId},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:d,theirProps:T,slot:D,defaultTag:le,features:re,visible:p,name:"Disclosure.Panel"}))}),Le=Object.assign(ee,{Button:ne,Panel:oe});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9122,5329,5430,1934,4434,2595,9774,2888,179], function() { return __webpack_exec__(47017); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);